import Modal from "@via/components/modal";
import { ModalSize } from "@via/utils/constants";

const DeleteNodeModal = ({ open, setOpen, nodeName, nodeType, onDelete }) => {
  // Resolving is what closes the modal now, so Modal owns the close rather than
  // this handler shutting the dialog itself inside a promise that never settled.
  const handleConfirmModal = async (): Promise<void> => {
    onDelete();
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Delete Node"
      confirmText="Confirm Delete"
      size={ModalSize.Large}
      onCancel={handleCancel}
      onConfirm={handleConfirmModal}>
      <form>
        <div className="mt-0">
          <div className="mb-4 text-sm text-gray-600">
            Are you sure you want to delete{" "}
            <span className="font-semibold">
              {nodeName} {nodeType}
            </span>
            ?
            <p className="py-2">
              This will remove the node from the visualization and cannot be
              undone.
            </p>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default DeleteNodeModal;
